<div class="flex column list-categories m-32 gap-16 gap-32 size" [ngClass]="{'heightError': !data?.length}">
	<div class="flex row space-between center">
		<div class="flex center">
			<h4>{{'category-creation.categories' | translateWithKeys}}</h4>
		</div>
		<div>
			<button mat-flat-button class="pointer bg-primary-darker text-accent-lighter category-btn" (click)="redirectToCreateCategory()">
				<mat-icon>add</mat-icon>
				<span>{{'category-creation.new_category' | translateWithKeys}}</span>
			</button>
		</div>
	</div>

	<div class="tab-header" *ngIf="authUser?.role !== Roles.ADMIN && hasPermission(PermissionsEnum.VIEW_ASSIGNED_CATEGORIES)">
		<button class="tab-btn" [class.tab-active]="selectedTabCategory === TabCategoryEnum.MY_CATEGORIES" (click)="selectedTabCategory = TabCategoryEnum.MY_CATEGORIES">
			{{'category-creation.my_categories' | translateWithKeys}}
		</button>
		<button class="tab-btn" [class.tab-active]="selectedTabCategory === TabCategoryEnum.ASSIGNED_CATEGORIES" (click)="selectedTabCategory = TabCategoryEnum.ASSIGNED_CATEGORIES">
			{{'category-creation.assigned_categories' | translateWithKeys}}
		</button>
	</div>

	<div [hidden]="selectedTabCategory !== TabCategoryEnum.MY_CATEGORIES">
		@if(showSpinner) {
			<div class="spinner-container">
				<mat-spinner></mat-spinner>
			</div>
		} @else {
		@if(data?.length || pagingData?.length) {
		<div class="flex row space-between center pv-32">
			<div class="flex row center search-btn">
				<div class="container-search pr-16 flex gap-16">
					<div class="search-by-container">
						<app-search-by [selectedSearchBy]="searchBy" [searchByOptions]="searchOptions" (searchBySelected)="handleSearchBySelected($event)"></app-search-by>
					</div>
					<div class="search-filter">
						<app-search-bar (searchString)="handleFilteredItems($event)" placeholder="general.search_by_category_name"></app-search-bar>
					</div>
				</div>
			</div>
			<div class="actions flex">
				<app-sort-by [selectedSortBy]="sortingValue" (sortByOption)="handleSortOptionSelected($event)"></app-sort-by>
			</div>
		</div>
		}
		<div class="categories-container flex column gap-24" [ngClass]="{'h-100': !data.length}">
			@for (category of data; track $index) {
				<div>
					<app-category-item [firstItem]="$index === 0" [model]="category" (dataOnChange)="handleDataChange($event)"></app-category-item>
				</div>
			} @empty {
				<div class="empty-state-container">
					@if(!pagingData?.length){
					<app-empty-state image="assets/images/computer-monitor.png"
						title="category-creation.you_havent_created_categories_yet"
						text="category-creation.create_category_you_see_it_here"></app-empty-state>
					}@else{
					<app-empty-state></app-empty-state>
					}
				</div>
			}
		</div>
		}
		@if(showSpinner || pagingData?.length){
			<div class="flex center bottom">
				<app-paging (currentPageNumber)="currentPage = $event" [options]="queryOptions" [scrollTopOnPageChange]="true" (itemsChange)="getPagingData($event)"></app-paging>
			</div>
		}
	</div>

	<ng-container *hasPermission="PermissionsEnum.VIEW_ASSIGNED_CATEGORIES">
		<div [hidden]="selectedTabCategory !== TabCategoryEnum.ASSIGNED_CATEGORIES">
			@if (showAssignedSpinner) {
				<div class="spinner-container">
					<mat-spinner></mat-spinner>
				</div>
			}
			@if (!showAssignedSpinner) {
				@if (hasAssignedData) {
					<div class="flex row space-between center pv-32">
						<div class="flex row center search-btn">
							<div class="container-search pr-16 flex gap-16">
								<div class="search-by-container">
									<app-search-by [selectedSearchBy]="searchBy" [searchByOptions]="searchOptions" (searchBySelected)="handleSearchBySelected($event)"></app-search-by>
								</div>
								<div class="search-filter">
									<mat-form-field class="search-bar" appearance="outline">
										<mat-icon class="search" svgIcon="search"></mat-icon>
										<input matInput [(ngModel)]="searchTerm" (ngModelChange)="search($event)" placeholder="{{'general.search' | translateWithKeys}}">
										@if(searchTerm){
											<mat-icon matSuffix (click)="clear()">close</mat-icon>
										}
									</mat-form-field>
								</div>
							</div>
						</div>
					</div>
				}
				<div class="categories-container flex column gap-24" [ngClass]="{'h-100': !assignedCategories.length}">
					@for (category of assignedCategories; track $index) {
						<div>
							<app-category-item [model]="category" [firstItem]="$index === 0" [isAssigned]="true" (dataOnChange)="handleDataChange($event)" (eventDuplicate)="handleEventChange($event)"></app-category-item>
						</div>
					} @empty {
						<div class="empty-state-container">
							@if(!assignedCategories?.length && !hasAssignedData){
								<app-empty-state image="assets/images/computer-monitor.png"
									title="category-creation.no_categories_assigned_yet"
									text="category-creation.no_categories_assigned_description"></app-empty-state>
							}@else{
								<app-empty-state></app-empty-state>
							}
						</div>
					}
				</div>
			}
		</div>
	</ng-container>

</div>
